import transformRequest from './helpers/transform';

/**
 * This transform Layer is used by component like
 * Histogram, Calendar and Hero
 */

/**
 * This method return a Request object after delete unnecesary paramter
 * @param {*} request Request Object pass to client request API axios at this moment
 */
const transformRatesAggregation = (request) => {
  // params to delete don't matter the value store
  const paramsDelete = [
    'location',
    'layoutMap',
    'layout',
    'layoutSettings',
    'tenantCode',
    'dateRange',
    'propertyCode',
    'travelerInterest',
    'airlineCode'
  ];

  // params to delete when has empty value
  const paramsEmpty = [];

  const cleanRequest = transformRequest(request, paramsDelete, paramsEmpty);

  return cleanRequest;
};

export default transformRatesAggregation;
